import { useQuery } from "@tanstack/react-query";
import { customFetch } from "../lib/customFetch";
import { buildUrl } from "../lib/buildUrl";

export function useGetStore() {
  const payload = useQuery({
    queryKey: ["getStore"],
    queryFn: async () => {
      return customFetch(buildUrl("/store"));
    },
  });

  return payload;
}
